import sample_1 from './basicsEpa.jpg';

export const basicsEpaImpressions = {
    sample_1,
};
